
import type { AsyncDataOptions } from '#app';
import type { FetchOptions } from 'ofetch';
import FetchFactory from '../factory';


class CollectionModule extends FetchFactory<any> {
  private RESOURCE = '/collection';

  async getFaqs(
    fetchOptions?: FetchOptions<'json', string>,
    asyncDataOptions?: AsyncDataOptions<FetchResponse<IFaq[]>>
  ) {
    return useAsyncData(
      "collection/getFaqs",
      () => {
        return this.call(
          `${this.RESOURCE}/faqs`,
          fetchOptions
        )
      },
      asyncDataOptions
    )
  };

}

export default CollectionModule;
